var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2069 10V3.25302H0.964341V10H3.2069ZM2.08591 2.33128C2.86793 2.33128 3.3547 1.81319 3.3547 1.16575C3.34013 0.503709 2.86796 0 2.10075 0C1.33366 0 0.832031 0.503719 0.832031 1.16575C0.832031 1.81322 1.31868 2.33128 2.07127 2.33128H2.08584H2.08591ZM4.44815 10H6.69071V6.23215C6.69071 6.0305 6.70528 5.82906 6.76449 5.68491C6.92661 5.28202 7.2956 4.86475 7.91509 4.86475C8.72658 4.86475 9.05122 5.48346 9.05122 6.39046V9.99995H11.2936V6.13129C11.2936 4.05889 10.1873 3.09462 8.71181 3.09462C7.50204 3.09462 6.97088 3.77084 6.67579 4.23141H6.69075V3.25288H4.4482C4.47763 3.88598 4.4482 9.99986 4.4482 9.99986L4.44815 10Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c81e6c20d016ac010f2f2dab439b6b0e.svg";
export { ForwardRef as ReactComponent };